var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"placeholder-container"},[_c('div',{staticClass:"placeholder-background-container",class:{
      'sm-wrapper':_vm.windowWidth < 576,
      'md-wrapper': _vm.windowWidth >= 576 && _vm.windowWidth <1200, 
      'lg-wrapper': _vm.windowWidth >= 1200
      }},[_c('div',{staticClass:"space"}),_c('div',{staticClass:"sun"}),_c('div',{staticClass:"moon"}),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-text-container"},[_c('div',{staticClass:"label-wrapper"},[_c('span',[_vm._v("东方久乐汽车电子(上海)股份有限公司")])])])
}]

export { render, staticRenderFns }